/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React, { useContext } from 'react';
import { ConfirmationDialog } from '@mummssoftware/common-ui';
import { OrdersGlobalContext } from '@mummssoftware/global-context';
import { CreateOrder } from './CreateOrder';
import { ConfirmOrder } from './ConfirmOrder';
import defaults from '../../translations/en.json';

export const OrderDialog = () => {
  const { openCreateOrder, displayConfirmation } = useContext(
    OrdersGlobalContext,
  );

  return openCreateOrder ? (
    <>
      <ConfirmationDialog
        title={defaults.createOrder}
        disableBackdropClick
        fullWidth
        maxWidth="sm"
        open={openCreateOrder}
        noScroll={window.innerHeight > 400}
        handleClick={() => null}
        noIcon
      >
        <CreateOrder />
      </ConfirmationDialog>
    </>
  ) : displayConfirmation ? (
    <ConfirmationDialog
      title={defaults.verifyOrder}
      disableBackdropClick
      fullWidth
      maxWidth="md"
      open={displayConfirmation}
      noScroll={window.innerHeight > 400}
      handleClick={() => null}
      noIcon
    >
      <ConfirmOrder />
    </ConfirmationDialog>
  ) : (
    <></>
  );
};
